import { render, staticRenderFns } from "./YbtPayOrderNotify.vue?vue&type=template&id=1c2af08e&scoped=true"
import script from "./YbtPayOrderNotify.vue?vue&type=script&lang=js"
export * from "./YbtPayOrderNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2af08e",
  null
  
)

export default component.exports